const decodeJwtPayload = (token) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(decodeURIComponent(escape(window.atob(base64))))
}

export function buildGoogleAuthPayload(credential) {
  const claims = decodeJwtPayload(credential)
  return {
    tokenId: credential,
    authData: {
      id: claims.sub,
      id_token: credential,
      expiration_date: claims.exp * 1000,
    },
    email: claims.email.toLowerCase(),
  }
}

export function applyGoogleCredentialToAuthStore(authStore, credential) {
  const payload = buildGoogleAuthPayload(credential)
  authStore.changeKey('email', payload.email)
  authStore.changeKey('isAttemptingLogIn', true)
  authStore.changeKey('isAttemptingSignUp', true)
  return authStore.googleLogin({
    tokenId: payload.tokenId,
    authData: payload.authData,
  })
}
